The input parameter for the `updateUnpostedPositionProfile` mutation.
